/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Group_MaintainInputs */

const en_directory_agent_readiness_group_maintain = /** @type {(inputs: Directory_Agent_Readiness_Group_MaintainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maintain`)
};

const zh_directory_agent_readiness_group_maintain = /** @type {(inputs: Directory_Agent_Readiness_Group_MaintainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`维护与排错`)
};

/**
* | output |
* | --- |
* | "Maintain" |
*
* @param {Directory_Agent_Readiness_Group_MaintainInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_group_maintain = /** @type {((inputs?: Directory_Agent_Readiness_Group_MaintainInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Group_MaintainInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_group_maintain(inputs)
	return zh_directory_agent_readiness_group_maintain(inputs)
});
export { directory_agent_readiness_group_maintain as "directory.agent_readiness.group.maintain" }